import { render, staticRenderFns } from "./internalImprovementTab.vue?vue&type=template&id=7a9c5276"
import script from "./internalImprovementTab.vue?vue&type=script&lang=js"
export * from "./internalImprovementTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a9c5276')) {
      api.createRecord('7a9c5276', component.options)
    } else {
      api.reload('7a9c5276', component.options)
    }
    module.hot.accept("./internalImprovementTab.vue?vue&type=template&id=7a9c5276", function () {
      api.rerender('7a9c5276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/internalImprovementTab.vue"
export default component.exports